import { zod4Resolver } from 'mantine-form-zod-resolver'
import { useForm } from '@mantine/form'
import { limitationValidation } from './validation'

export const useLimitationForm = () => {
  return useForm({
    mode: 'controlled',
    validate: zod4Resolver(limitationValidation()),
    initialValues: {
      my_products: 0,
      my_products_limit: false,
      product_by_url: 0,
      product_by_url_limit: false,
    },
    transformValues: (values) => {
      return {
        limit: {
          my_products: Number(values.my_products),
          my_products_limit: values.my_products_limit,
          product_by_url: Number(values.product_by_url),
          product_by_url_limit: values.product_by_url_limit,
        }
      }
    }
  })
}